import { createApi } from '@reduxjs/toolkit/query/react';

import { COMMANDAPI, COREAPI, NOTIFICATIONAPI, ORCHESTRATIONAPI, QUERYAPI, WALLETAPI } from '@/constants/global';

import { createCoreBaseQuery } from './base-query-with-reauth';

// Every slice below sends the core JWT and recovers from a 401 the same way — see
// `base-query-with-reauth.ts`. Do not reach for a bare `fetchBaseQuery` here.

export const walletApiSlice = createApi({
	reducerPath: 'walletApi',
	// Every tag a wallet-service endpoint provides or invalidates must be declared here.
	// RTK Query IGNORES an undeclared tag silently — no warning, no error — so a mutation
	// would look like it refreshed the list and simply would not.
	tagTypes: ['WalletBalance', 'AdminWallet', 'AdminWalletList', 'CouponSchedule'],
	baseQuery: createCoreBaseQuery(`${WALLETAPI}/api/v1`),
	endpoints: () => ({}),
});
export const coreApiSlice = createApi({
	reducerPath: 'coreApi',
	tagTypes: ['ElectionObservers', 'ObserverManagement', 'ConstituencyMapping'],
	baseQuery: createCoreBaseQuery(`${COREAPI}/api/v1`),
	endpoints: () => ({}),
});
export const commandApiSlice = createApi({
	reducerPath: 'commandApi',
	// Undeclared tags are ignored silently by RTK Query — see the note on walletApiSlice.
	tagTypes: ['VoterVerificationRecent'],
	baseQuery: createCoreBaseQuery(`${COMMANDAPI}/api/v1`),
	endpoints: () => ({}),
});
export const queryApiSlice = createApi({
	reducerPath: 'queryApi',
	baseQuery: createCoreBaseQuery(`${QUERYAPI}/api/v1`),
	endpoints: () => ({}),
});
/**
 * api.notification — the WhatsApp read surface.
 *
 * Base is `${NOTIFICATIONAPI}/api/v1` rather than the bare host, matching every sibling slice, so
 * endpoint paths read `/whatsapp/capabilities`.
 *
 * Auth here is not uniform, and getting it wrong is this service's documented most-common failure:
 * `/capabilities` takes a plain bearer token (any authenticated user, so a channel selector can
 * render before permissions resolve), while templates / consent / message detail additionally
 * require an action-key claim. Both are covered by the bearer below; a 403 on the latter group means
 * the key is missing from the JWT, and because claims are stamped at mint time the user must log out
 * and back in for a newly granted key to arrive.
 */
export const notificationApiSlice = createApi({
	reducerPath: 'notificationApi',
	tagTypes: ['WhatsAppTemplates'],
	baseQuery: createCoreBaseQuery(`${NOTIFICATIONAPI}/api/v1`),
	endpoints: () => ({}),
});
export const orchApiSlice = createApi({
	reducerPath: 'orchestrationApi',
	baseQuery: createCoreBaseQuery(`${ORCHESTRATIONAPI}/api/v1`),
	endpoints: () => ({}),
});
